import { DOCUMENT } from "@angular/common";
import { Injectable, inject } from "@angular/core";
import { RequestBodyContextBuilder } from "../builders/request-body-context.builder";
import { ContextService } from "./context.service";

@Injectable({
  providedIn: "root",
})
export class QuotationRecoveryService {
  constructor(private contextService: ContextService) {}
  private document = inject(DOCUMENT);

  quotationRecovery(
    reference: string,
    productName: string,
    brancheCode: string,
    distributorCode: string,
    email: string
  ) {
    try {
      const requestBody = new RequestBodyContextBuilder()
        .setReferenceDevis(reference)
        .setProduit(productName)
        .setBranche(brancheCode)
        .setCodeVendeur(distributorCode)
        .setEmail(email)
        .build();
      this.contextService.createContext(requestBody).subscribe({
        next: redirectUrl => {
          this.document?.defaultView?.open(redirectUrl, "_blank");
        },
        error: error => {
          console.error("Erreur lors de la création du contexte", error);
        },
      });
    } catch (error) {
      console.error("Erreur lors de la construction du requestBody", error);
    }
  }
}
